export const MENU_ID = 'project/classic';

export const SECTION_ID = {
	ISSUES: 'issues',
	REPORTS: 'reports',
	SETTINGS: 'settings',
	REQUESTS: 'requests',
} as const;
